import type { BrandStatus, BudgetRange, ProjectType, Timeline } from '@/domain/brief/BriefOptions';
import type { Email } from '@/domain/brief/Email';

export interface BriefProps {
  readonly projectType: ProjectType;
  readonly brandStatus: BrandStatus | null;
  readonly budget: BudgetRange;
  readonly timeline: Timeline;
  readonly fullName: string;
  readonly email: Email;
  readonly company: string | null;
  readonly phone: string | null;
  readonly message: string | null;
}

/** Contrat JSON envoyé à l'API (snake_case côté Go). */
export interface BriefPayload {
  readonly project_type: ProjectType;
  readonly brand_status: BrandStatus | null;
  readonly budget: BudgetRange;
  readonly timeline: Timeline;
  readonly full_name: string;
  readonly email: string;
  readonly company: string | null;
  readonly phone: string | null;
  readonly message: string | null;
}

/** Entité valide par construction : on ne l'obtient que via `BriefDraft.toBrief()`. */
export class Brief {
  readonly props: BriefProps;

  constructor(props: BriefProps) {
    this.props = props;
  }

  toPayload(): BriefPayload {
    const { props } = this;
    return {
      project_type: props.projectType,
      brand_status: props.brandStatus,
      budget: props.budget,
      timeline: props.timeline,
      full_name: props.fullName,
      email: props.email.value,
      company: props.company,
      phone: props.phone,
      message: props.message,
    };
  }
}
